<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item label="Mobile / Email" prop="mobile" >
        <a-input v-model="form.mobile" placeholder="Please enter mobile or email" />
      </a-form-model-item>
      <a-form-model-item label="Pitch" prop="pitchId" >
        <a-select
          v-model="form.pitchId"
          placeholder="Please select pitch"
          :loading="pitchLoading"
          allow-clear
          style="width: 100%"
          option-filter-prop="children"
          show-search
        >
          <a-select-option
            v-for="item in pitchOptions"
            :key="item.id"
            :value="item.id"
          >
            {{ item.pitchName }}
          </a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="Order Start Time" prop="startTime" >
        <a-date-picker
          v-model="form.startTime"
          style="width: 100%"
          format="YYYY-MM-DD HH:mm:ss"
          valueFormat="YYYY-MM-DD HH:mm:ss"
          :show-time="{ format: 'HH:mm:ss' }"
          :disabled-date="disabledAfterToday"
          allow-clear
        />
      </a-form-model-item>
      <a-form-model-item label="Order End Time" prop="endTime" >
        <a-date-picker
          v-model="form.endTime"
          style="width: 100%"
          format="YYYY-MM-DD HH:mm:ss"
          valueFormat="YYYY-MM-DD HH:mm:ss"
          :show-time="{ format: 'HH:mm:ss' }"
          :disabled-date="disabledAfterToday"
          allow-clear
        />
      </a-form-model-item>
      <a-form-model-item label="Amount" prop="payMoney" >
        <a-input v-model="form.payMoney" placeholder="Please enter amount" />
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            Save
          </a-button>
          <a-button type="dashed" @click="cancel">
            Cancel
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getOrder, addOrder, updateOrder } from '@/api/golf/order'
import { listPitch } from '@/api/golf/pitch'
import moment from 'moment'

export default {
  name: 'CreateForm',
  props: {
  },
  components: {
  },
  data () {
    return {
      submitLoading: false,
      formTitle: '',
      pitchLoading: false,
      pitchOptions: [],
      form: {
        id: null,

        mobile: null,

        pitchId: null,

        startTime: null,

        endTime: null,

        payMoney: null,

        createTime: null,

        remark: null

      },
      formType: 1,
      open: false,
      rules: {
        mobile: [
          { required: true, message: 'Please enter mobile or email', trigger: 'blur' }
        ],
        pitchId: [
          { required: true, message: 'Please select pitch', trigger: 'change' }
        ],
        startTime: [
          { required: true, message: 'Please select order start time', trigger: 'change' }
        ],
        endTime: [
          { required: true, message: 'Please select order end time', trigger: 'change' }
        ],
        payMoney: [
          { required: true, message: 'Please enter amount', trigger: 'blur' }
        ]
      }
    }
  },
  filters: {
  },
  created () {
    this.loadPitchOptions()
  },
  computed: {
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    disabledAfterToday (current) {
      if (!current) return false
      return current <= moment().endOf('day')
    },
    loadPitchOptions () {
      this.pitchLoading = true
      listPitch({})
        .then(res => {
          const list = Array.isArray(res.data) ? res.data : []
          this.pitchOptions = list
        })
        .finally(() => {
          this.pitchLoading = false
        })
    },
    onClose () {
      this.open = false
    },
    cancel () {
      this.open = false
      this.reset()
    },
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        mobile: null,
        pitchId: null,
        startTime: null,
        endTime: null,
        payMoney: null,
        createTime: null,
        remark: null
      }
      this.$nextTick(() => {
        if (this.$refs.form) {
          this.$refs.form.resetFields()
        }
      })
    },
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = 'Add'
    },
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getOrder({ id: id }).then(response => {
        this.form = response.data
        if (this.form.pitchId !== null && this.form.pitchId !== undefined && this.form.pitchId !== '') {
          this.form.pitchId = Number(this.form.pitchId)
        }
        this.open = true
        this.formTitle = 'Edit'
      })
    },
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            updateOrder(this.form).then(response => {
              this.$message.success(
                'Updated successfully',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addOrder(this.form).then(response => {
              this.$message.success(
                'Added successfully',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
